export default __webpack_public_path__ + "static/media/project3.9e84e548.jpg";